export { baseCheckboxPropDefs as checkboxPropDefs } from './_internal/base-checkbox.props.js';
